import { useMemo } from 'react'
import { useQuery } from '@apollo/client'

import {
  GetSetupFlowSavingsAccountEffectiveInterestRate,
  GetSetupFlowSavingsAccountEffectiveInterestRateQueryResponse,
} from './graphql/getSavingsAccountEffectiveInterestRate.generated'

export const useSetupFlowSavingsAccountEffectiveInterestRateQuery = () => {
  const { loading, data } = useQuery<
    GetSetupFlowSavingsAccountEffectiveInterestRateQueryResponse,
    never
  >(GetSetupFlowSavingsAccountEffectiveInterestRate, {
    errorPolicy: 'all',
  })

  const effectiveInterestRate = useMemo(() => {
    return data?.getEntity?.savingsAccountProduct?.effectiveInterestRate
  }, [data?.getEntity?.savingsAccountProduct?.effectiveInterestRate])

  return {
    isLoadingEffectiveInterestRate: loading,
    effectiveInterestRate,
  }
}
